import React from "react";
import { motion } from "framer-motion";
import { Compass, Eye, Layers, Sparkles, MapPin } from "lucide-react";

const DISCOVERIES = [
  {
    icon: Eye,
    title: "Vas a verlo",
    text: "Saldrás sabiendo qué personaje ha estado dirigiendo tus decisiones sin que te dieras cuenta.",
  },
  {
    icon: Layers,
    title: "Vas a entenderlo",
    text: "Comprenderás cuándo se formó, qué necesidad estaba cubriendo y por qué se sostiene hoy.",
  },
  {
    icon: Sparkles,
    title: "Vas a integrarlo",
    text: "Sabrás cómo trabaja el Método SIRCS sobre la parte consciente y subconsciente que lo mantiene vivo.",
  },
  {
    icon: MapPin,
    title: "Vas a identificarlo",
    text: "En tus relaciones, en tu dinero, en tus decisiones. Vas a reconocerlo en tiempo real.",
  },
  {
    icon: Compass,
    title: "Vas a poder elegir",
    text: "Dejarás de reaccionar en piloto automático y comenzarás a responder desde quien decides ser.",
  },
];

export default function TransformationSection() {
  return (
    <section
      id="segundo-acto"
      className="section-light relative py-24 md:py-36 overflow-hidden"
      data-testid="transformation-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <p className="overline mb-6">◇ Tu segundo acto</p>
          <h2 className="font-serif font-normal text-5xl sm:text-6xl lg:text-7xl text-[#0B0E13] leading-[1.05] tracking-[-0.01em]">
            Dejar de reaccionar.
            <br />
            <span className="italic text-[#6E7580]">Empezar a elegir.</span>
          </h2>
          <div className="gold-divider mt-8" />
          <p className="mt-8 text-lg sm:text-xl text-[#2A303A] leading-[1.7] max-w-2xl font-light font-sans">
            Una experiencia gratuita en directo con Santi Lorenzo para comprender cómo se
            construyen los patrones que te mantienen en piloto automático y conocer cómo trabaja
            el Método SIRCS sobre la parte consciente y subconsciente.
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          {DISCOVERIES.map((d, i) => {
            const Icon = d.icon;
            return (
              <motion.div
                key={d.title}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="relative group"
                data-testid={`outcome-${i}`}
              >
                <div className="paper p-7 h-full hover:-translate-y-1 transition-all duration-300">
                  <Icon className="text-[#C7AA78] mb-5" size={26} strokeWidth={1.5} />
                  <h3 className="font-serif text-xl text-[#0B0E13] mb-3 font-normal tracking-[-0.005em] leading-tight">
                    {d.title}
                  </h3>
                  <p className="text-[#2A303A] text-sm leading-relaxed font-light font-sans">
                    {d.text}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="mt-16 text-center"
        >
          <a
            href="#reservar"
            className="btn-gold inline-flex items-center gap-3"
            data-testid="transformation-cta"
          >
            Avísame de la próxima
            <span>→</span>
          </a>
          <p className="text-sm text-[#6E7580] mt-5 font-medium font-sans">
            Masterclass gratuita en directo · Próxima fecha muy pronto
          </p>
        </motion.div>
      </div>
    </section>
  );
}
